<template>
  <div class="row">&nbsp;</div>
  <div class="container-fluid">
    <div class="row">
      

      <div class="col-xl-12">
        <div class="card">
          <div class="card-header">
            <div class="header-top">
              <b class="m-0">{{ t("order") }}: {{ this.$route.params.confirm_key }}  
                <br>{{ t("quantity") }}: {{ this.length }} {{ t("piece") }}
                <br>{{ t("paymentDate") }}: {{ this.payment_date }}
                <br>{{ t("imageSortHint") }}</b><br>
                <br>
            </div>
          </div>
          <div class="card-body media-section media-section-image" v-if="this.orders_sort.length > 0">
            <div class="media-section-header">
              <Var class="media-title">{{ t("image") }}</Var>
              <span class="media-count">{{ this.orders_sort.length }} {{ t("piece") }}</span>
            </div>
            <div class="container-fluid" v-if="this.loadding ==='N'">
                <figure v-for="(src, index) in displayed_orders" :key="index" class="img-item">
                  <div class="gallery gellerycont">

                    <img 
                      :src="this.s3_url+'/'+src.image_thumbnail"
                      :alt="src.original_file_name"
                      loading="lazy"
                      @load="markImageLoaded('image', src, index)"
                      @error="markImageLoaded('image', src, index)"
                    />

                    <label 
                      class="btn"
                      :class="{ 'btn-ready': isImageLoaded('image', src, index) }"
                      :for="src.id"
                      >{{this.system_prefix}}{{src.photographer_id}}<br>{{src.original_file_name.replace(' ','')}}</label
                    >
                  </div>
                </figure>
                <div
                  v-if="displayed_orders.length < orders_sort.length"
                  ref="imageLoadMoreTrigger"
                  class="load-more-trigger"
                ></div>
              </div>
          </div>
          <div class="d-flex justify-content-center" v-if="this.loadding === 'Y'" >
              <img  style="align-items: center; width: 60px" src="../../assets/images/running_loading.svg" />
          </div>

          <div v-if="this.orders.length === 0 && this.loadding === 'N'">
            <div class="d-flex justify-content-center">
              <br>{{ t("imageStorageExpired") }}
            </div>
          </div>
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.btn:disabled {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  color: #fff !important;
  opacity: 0.65;
  cursor: not-allowed !important;
}
.table-fit {
  width: 1px;
}
</style>
<script>

import VuejsPaginateNext from "../../components/Paginate.vue";
import axios from "axios";

const LANGUAGE_TEXT = {
  en: {
    order: "Order",
    quantity: "Quantity",
    piece: "items",
    paymentDate: "Payment Date",
    imageSortHint: "Images are displayed in order of photographer ID and file name",
    image: "Image",
    imageStorageExpired: "The image storage period has ended",
  },
  th: {
    order: "คำสั่งซื้อ",
    quantity: "จำนวน",
    piece: "ใบ",
    paymentDate: "วันที่ชำระเงิน",
    imageSortHint: "รูปจะแสดงเรียงตามรหัสของช่างภาพ และชื่อรูปภาพ",
    image: "Image",
    imageStorageExpired: "หมดเวลาจัดเก็บข้อมูลรูปภาพ",
  },
};

export default {
  name: "order",
  components: {
    paginate: VuejsPaginateNext,
  },
  setup() {},
  data() {
    return {
      orders: [],
      length: 0,
      payment_date: null,
      images_paid: [],
      page_tab: 0,
      loadding: "N",
      page: 1,
      init_page_size: 7,
      batch_size: 100,
      visible_order_count: 100,
      order_observer: null,
      use_scroll_fallback: false,
      s3_url: process.env.VUE_APP_AWS_S3_URL,
      //s3_url: process.env.VUE_APP_AWS_S3_URL,
      event_key: this.$route.params.q,
      order_id: this.$route.params.confirm_key.substring(5),
      token: localStorage.getItem("jwt"),
      system_prefix: process.env.VUE_APP_SYSTEM_PREFIX,
      loadedImageKeys: {},

    };
  },
  computed: {
    currentLanguage() {
      return (process.env.VUE_APP_LANGUAGE || "").toLowerCase() === "en"
        ? "en"
        : "th";
    },
    
    orders_sort() {
      if(this.orders !== null){
        //if(this.payment_gateway ==='GBP'){
        //  return this.orders
        //}else{
        //  return this.orders
        //  .sort((a,b)=> (a.photographer_id - b.photographer_id || a.original_file_name.localeCompare(b.original_file_name)  ));
        //}
        return this.orders
          .sort((a,b)=> (a.photographer_id - b.photographer_id || a.original_file_name.localeCompare(b.original_file_name)  ));
        }
      
    },
    displayed_orders() {
      return this.orders_sort.slice(0, this.visible_order_count);
    },
  },
  async mounted() {
    
    try {
      this.loadding = "Y";
      let data = {
        confirm_key: this.$route.params.confirm_key,
        order_id: this.$route.params.order_id
      }
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "/v1/order/order-paid-view-cart/" + this.$route.params.q,data,
        {
          headers
        }
      );

      //console.log("response:"+JSON.stringify(response.data))
      if (response.data.status === "success") {
        this.loadedImageKeys = {};
        this.orders = response.data.body.length > 0 ? JSON.parse(response.data.body) : [];
        this.visible_order_count = this.batch_size;
        this.length = response.data.length;
        this.payment_date = response.data.payment_date;
        this.payment_gateway = response.data.payment_gateway;
        //this.images_paid = this.orders.images_paid
        //this.orders = JSON.parse(response.data.body.images_paid)
        
      }
      this.loadding = "N";
      this.$nextTick(() => {
        this.setupInfiniteScroll();
      });
      
    } catch (error) {
      alert("พบข้อผิดพลาดกรุณาติดต่อผู้ดูแลระบบ", error);
      //this.$router.push({ path: "/auth/login" });
      this.loadding = "N";
    }
  },
  beforeUnmount() {
    this.clearInfiniteScroll();
  },
  beforeDestroy() {
    this.clearInfiniteScroll();
  },
  methods: {
    t(key) {
      return LANGUAGE_TEXT[this.currentLanguage][key] || LANGUAGE_TEXT.en[key] || key;
    },
    getImageLoadKey(type, src, index) {
      return `${type}-${src.id || src.image_thumbnail || src.original_file_name || index}`;
    },
    markImageLoaded(type, src, index) {
      this.loadedImageKeys[this.getImageLoadKey(type, src, index)] = true;
    },
    isImageLoaded(type, src, index) {
      return !!this.loadedImageKeys[this.getImageLoadKey(type, src, index)];
    },
    loadMoreOrders() {
      if (this.visible_order_count >= this.orders_sort.length) {
        return;
      }
      this.visible_order_count += this.batch_size;
    },
    setupInfiniteScroll() {
      this.clearInfiniteScroll();

      if (this.visible_order_count >= this.orders_sort.length) {
        return;
      }

      if (typeof window !== "undefined" && "IntersectionObserver" in window) {
        this.order_observer = new IntersectionObserver(
          (entries) => {
            const [entry] = entries;
            if (entry && entry.isIntersecting) {
              this.loadMoreOrders();
            }
          },
          { root: null, rootMargin: "300px 0px", threshold: 0 }
        );

        if (this.$refs.imageLoadMoreTrigger) {
          this.order_observer.observe(this.$refs.imageLoadMoreTrigger);
        }
      } else {
        this.use_scroll_fallback = true;
        window.addEventListener("scroll", this.handleWindowScroll, { passive: true });
      }
    },
    clearInfiniteScroll() {
      if (this.order_observer) {
        this.order_observer.disconnect();
        this.order_observer = null;
      }

      if (this.use_scroll_fallback) {
        window.removeEventListener("scroll", this.handleWindowScroll);
        this.use_scroll_fallback = false;
      }
    },
    handleWindowScroll() {
      const trigger = this.$refs.imageLoadMoreTrigger;
      if (!trigger) {
        return;
      }

      const rect = trigger.getBoundingClientRect();
      if (rect.top <= window.innerHeight + 300) {
        this.loadMoreOrders();
      }
    },
  },
};
</script>

<style scoped>
.align-to-right {
  float: right;
  padding: 10px;
  background-color: hotpink;
}

input[type="checkbox"] {
  display: none;
}

.media-section {
  border: 1px solid #e9eef5;
  border-radius: 12px;
  margin: 0 0 14px;
  padding: 14px;
}

.media-section-image {
  background: linear-gradient(180deg, #f7fcf7 0%, #ffffff 100%);
}

.media-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 2px 10px;
  margin-bottom: 10px;
  border-bottom: 1px dashed #d8e1ee;
}

.media-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
}

.media-count {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  background: #eaf0fb;
  border: 1px solid #d2ddf1;
}

div.gellerycont:hover {
  cursor: pointer;
  opacity: 0.9;
}
@media screen and (min-width: 451px) and (max-width: 9000px) {
  div.gellerycont {
    margin: 1px;
    float: left;
    min-height: auto;
    max-height: 193px;
    min-width: auto;
    max-width: 290px;
    
  }

  div.gellerycont img {
    position: relative;
    min-height: 100%;
    max-height: 194.66px;
    min-width: 100%;
    padding: 1px;
    max-width: 290px;
  }
}

@media (min-width: 300px) and (max-width: 450px) {
  .media-section {
    padding: 10px;
  }

  .media-title {
    font-size: 14px;
  }

  .media-count {
    font-size: 11px;
    padding: 2px 8px;
  }

  div.gellerycont {
    width: 49%;
    float: left;
    margin: 1px;
    padding: 2px;
    border: 1px solid #ccc;
  }

  div.gellerycont img {
    min-height: 100%;
    max-height: 100%;
    min-width: 100%;
    max-width: 100%;
    padding: 2px;
  }
}

.gellerycont {
  position: relative;
  width: auto;
  height: auto;
}

.gellerycont::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 44%;
  background: linear-gradient(to top, rgba(170, 170, 170, 0.82), rgba(116, 116, 116, 0));
  pointer-events: none;
}

.gellerycont img {
  height: auto;
  width: auto;
}

.gellerycont .btn {
  position: absolute;
  bottom: -0px;
  left: 50%;
  transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.75);
  color: white;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.25;
  padding: 4px 8px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.55);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.45);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.95);
  width: calc(100% - 14px);
  max-width: 280px;
  text-align: center;
  white-space: normal;
  overflow-wrap: anywhere;
  z-index: 1;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease;
}

.gellerycont .btn.btn-ready {
  opacity: 1;
  visibility: visible;
}

.load-more-trigger {
  width: 100%;
  height: 1px;
  clear: both;
}

.img-item {
  animation: fadeUpIn 0.35s ease;
}

@keyframes fadeUpIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}


</style>
